export default __webpack_public_path__ + "static/media/clobber5.132caac2.png";